export default "__VITE_ASSET__CgEXBkSB__"